/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { DocumentRequirementOriginType } from '../models/document-requirement-origin-type';
import { DocumentRequirementType } from '../models/document-requirement-type';
import { Reference } from '../models/reference';

/**
 * Document Requirement DTO
 */
export interface DocumentRequirementCreate {
  case?: Reference;
  client?: Reference;
  clientProduct?: Reference;
  opportunity?: Reference;
  origin?: DocumentRequirementOriginType;
  party?: Reference;
  requirementType?: DocumentRequirementType;
}

export class DocumentRequirementCreate {
  case?: Reference;
  client?: Reference;
  clientProduct?: Reference;
  opportunity?: Reference;
  origin?: DocumentRequirementOriginType;
  party?: Reference;
  requirementType?: DocumentRequirementType;

  constructor(value: DocumentRequirementCreate) {
    this.case = value?.case ? new Reference(value.case) : undefined;
    this.client = value?.client ? new Reference(value.client) : undefined;
    this.clientProduct = value?.clientProduct ? new Reference(value.clientProduct) : undefined;
    this.opportunity = value?.opportunity ? new Reference(value.opportunity) : undefined;
    this.origin = value?.origin ? Object.entries(Object.values(DocumentRequirementOriginType)).flatMap((x) => x).find(x => x === value.origin) as DocumentRequirementOriginType : undefined;
    this.party = value?.party ? new Reference(value.party) : undefined;
    this.requirementType = value?.requirementType ? new DocumentRequirementType(value.requirementType) : undefined;
  }
}
